import PocketBase from 'pocketbase';

const pocketbaseUrl = process.env.REACT_APP_POCKETBASE_URL;

if (!pocketbaseUrl) {
  console.error('Missing REACT_APP_POCKETBASE_URL environment variable');
}

export const pb = new PocketBase(pocketbaseUrl);
